import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";
import { LINE_OF_BUSINESS_ENUM } from "shared/constant";
const parentBreadCrumbs = [
  { title: "menu_sidebar_family" },
  { title: "menu_sidebar_family_plan_setup" },
  { title: "menu_sidebar_family_plan_setup_b2b" },
  { title: "menu_sidebar_family_plan_setup_plans", link: "/family/plan-setup/b2b/plans" }
];

const ShelfPlanListing = Loadable({
  loader: () => import("container/bac/b2b/plans/listing"),
  loading() {
    return <Loader />;
  }
});
const ShelfPlanAdd = Loadable({
  loader: () => import("container/bac/b2b/plans"),
  loading() {
    return <Loader />;
  }
});

export const familyPlanB2BRoutes: IRoute[] = [
  {
    path: "/family/plan-setup/b2b/plans",
    element: <ShelfPlanListing lineOfBusiness={LINE_OF_BUSINESS_ENUM.FAMILY} />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/family/plan-setup/b2b/plans/details/:id?",
    element: <ShelfPlanAdd lineOfBusiness={LINE_OF_BUSINESS_ENUM.FAMILY} />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
